import { string, z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { latitude, longitude } from '~/prix/types/presets/geo'

export const communityObject = z.object({
  id: z.string().uuid(),
  name: z.string(),
  whatsappGroupLink: z.string().url('URL Inválida').nullish(),
  latitude: latitude(),
  longitude: longitude(),
  color: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  sourceFilter: z.string().nullish(),
  alternativeNames: z.array(z.string()).optional().default([]),
  openStreetMapCode: z.number().nullish(),
  kind: z
    .enum([
      'deprecated',
      'manualDrawing',
      'authorityProvided',
      'openStreetMapSourced',
      'smartMapping',
    ])
    .nullish(),
  shape: z.union([z.string(), z.record(z.any())]).nullish(),
  shapeHighResolution: z.union([z.string(), z.record(z.any())]).nullish(),
  municipalityId: z.number().nullish(),
  countryId: z.number().nullish(),
  macroRegionId: z.number().nullish(),
  stateId: z.number().nullish(),
  mesoRegionId: z.number().nullish(),
  microRegionId: z.number().nullish(),
  districtId: z.number().nullish(),
  point: z.union([z.string(), z.record(z.any())]).nullish(),
})

export type CommunityType = z.infer<typeof communityObject>
